module.exports = __webpack_public_path__ + "img/20.cff822f3.png";